
import Judge from "../../../assets/outline/Judge.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function JudgeIcon({ className, dataTestid = "JudgeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Judge data-testid={dataTestid} className={classes} {...rest} />
  );
}
